import React from 'react'
import { ReactComponent as ErrorIcon } from '../../assets/images/error.svg'
import './error.scss'

const Error = () => {
  return (
    <div className={'error-page-container'}>
      <ErrorIcon className={'error-page-image'} alt='error' />
      <h3 className={'error-font'}>Page not found</h3>
      <h4>Oops! The page you are looking was not found!</h4>
    </div>
  )
}

export default Error
